class HeaderController extends window.StimulusController {
  static targets = ["subMenu", "headerDrawer", "wrapper"];

  #activeLinkTitle = undefined;

  connect() {
    document.addEventListener("scroll", this.toggleShadow);
  }

  toggleShadow = () => {
    const shadowClass = "tw-shadow-[0_5px_10px_0_rgba(0,0,0,.08)]";

    if (window.scrollY > 0) {
      return this.wrapperTarget.classList.add(shadowClass);
    }

    return this.wrapperTarget.classList.remove(shadowClass);
  };

  toggleHeaderDrawer() {
    const event = new CustomEvent("drawer:toggle", { bubbles: true });
    document.dispatchEvent(event);
  }

  get #activeSubMenuTarget() {
    return this.subMenuTargets.find(
      (subMenu) => subMenu.dataset.linkTitle === this.#activeLinkTitle,
    );
  }

  showSubMenu(event) {
    const title = event.target.dataset.linkTitle;

    if (this.#activeLinkTitle !== title) {
      this.hideSubMenu();
    }

    this.#activeLinkTitle = title;
    this.#activeSubMenuTarget?.classList.remove("tw-hidden");
  }

  hideSubMenu() {
    this.#activeSubMenuTarget?.classList.add("tw-hidden");
  }
}

Stimulus.register("header", HeaderController);
